defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Naming',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent'
  ],
  function (m, Ensighten, PlayTogetherApi, CtaButton, CardContent) {
    // Context:
    var Naming = {
      controller: function (args) {
        Object.assign(this, args.controller);

        this.choseNameDictionary = this.rootDictionary.get.bind({ prefix: 'CreateClub/Flow/ChoseName/' });

        this.helpOverlayTitle(this.choseNameDictionary('HelpOverlay/Title'));
        this.helpOverlayDescription(this.choseNameDictionary('HelpOverlay/Description'));

        this.flowTitle(this.choseNameDictionary('Title'));
        this.flowDescription(this.choseNameDictionary('Description'));
        this.property('flowGoBack', () => {
          window.history.back();
        });
        this.canEditClubName(true);

        this.gettingRandomName = m.prop(false);
        this.getRandomName = () => {
          this.gettingRandomName(true);
          PlayTogetherApi.getRandomClubName().then((response) => {
            this.clubName(response);
            this.gettingRandomName(false);
          });
        };

        this.validatingClubName = m.prop(false);
        this.validateClubName = () => {
          this.validatingClubName(true);
          PlayTogetherApi.validateClubName(this.clubName())
            .then(() => {
              this.validatingClubName(false);
              this.clubModel().save();
              this.currentStep('themeDesign');
            })
            .catch((err) => {
              this.validatingClubName(false);
              this.error(err);
            });
        };

        setTimeout(() => {
          m.redraw();
        }, 0);

        Ensighten.pushGaEvent('spil_sammen', 'create_club', 'navngiv_din_klub', null, true);
      },
      view: function (controller, ignoreArgs, { flowFooter }) {
        const isClubNameLengthValid = controller.clubModel().getClubNameRemainingCharactersCount() >= 0;
        const footerContent = CtaButton({
          text: controller.choseNameDictionary('SaveAndContinueButton'),
          onClick: controller.validateClubName,
          loading: controller.validatingClubName(),
          disabled: (!controller.clubName()?.length > 0) || !isClubNameLengthValid || controller.gettingRandomName(),
          options: ['primary']
        });

        // Return:
        return CardContent({
          $content: [
            !isClubNameLengthValid ?
              m('.play-together-error-text', controller.dictionary('Flow/LengthNameExceeded')) : null,
            CtaButton({
              onClick: controller.getRandomName,
              text: controller.choseNameDictionary('RandomNameButton'),
              icon: 'random',
              loading: controller.gettingRandomName(),
              disabled: controller.validatingClubName(),
              options: ['small']
            })
          ],
          $footer: flowFooter(footerContent)
        });
      }
    };

    // Public functions:
    return Naming;
  });
